module.exports = __webpack_public_path__ + "static/media/portfolio.4b632d51.png";